/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */


import { UserCustomContentFamilyInformation } from '../../components/add-family-information/user-custom-content-family-information/user-custom-content-family-information.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class UserCustomContentFamilyInformationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = UserCustomContentFamilyInformation;
    sysquePopupConfig.width = 1080;
    sysquePopupConfig.height = 815;
    sysquePopupConfig.componentTitle = '';
    sysquePopupConfig.visible = true;
  }
}